export default "__VITE_ASSET__CLvOzD4s__"